import { api } from '@/lib/api';
import type { LabDetailsRequest, LabDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/lab';

export async function save_lab_details(input: LabDetailsRequest): Promise<LabDetailsResponse> {
  const res = await api.post<LabDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_lab_details(): Promise<LabDetailsResponse | null> {
  const res = await api.get<LabDetailsResponse | null>(URL);
  return res.data;
}
